import { useTranslation } from 'react-i18next'
import classNames from 'classnames/bind'

import { SubmissionDetailsSection } from '../../components/submissionDetailsSection/SubmissionDetailsSection'

import { CandidateNominationProps } from './CandidateNomination.types'
import { CardContent, CardDashboard, Flex } from '@percent/lemonade'
import styles from './CandidateNomination.module.scss'

const cx = classNames.bind(styles)

export function CandidateNomination({ nomination, index }: Readonly<CandidateNominationProps>) {
  const { t } = useTranslation()

  const details = nomination?.details

  const organisationContactName = `${nomination.organisationContact?.firstName} ${nomination.organisationContact?.lastName}`
  const nominatorFullName = `${nomination.nominator.firstName} ${nomination.nominator.lastName}`.trim()

  return (
    <CardDashboard
      key={nomination.id}
      title={t('grants.nominations.nomination', { number: index })}
      data-testid={`nomination-${index}`}
    >
      {nominatorFullName && (
        <CardContent title={t('grants.nominations.nomination.fullName')} testId={`nominator-full-name-${index}`}>
          {nominatorFullName}
        </CardContent>
      )}
      <CardContent title={t('grants.nominations.nomination.email')} testId={`nominator-email-${index}`}>
        <a href={`mailto:${nomination.nominator.email}`}>{nomination.nominator.email}</a>
      </CardContent>
      {nomination.nominator.group && (
        <CardContent title={t('grants.nominations.nomination.group')} testId={`nominator-group-${index}`}>
          {nomination.nominator.group}
        </CardContent>
      )}
      {nomination.organisationContact && (
        <CardContent
          title={t('grants.nominations.nomination.organisationContact')}
          testId={`organisation-contact-${index}`}
        >
          <Flex className={cx(styles.organisationContactDetails)}>
            {organisationContactName && <span>{organisationContactName}</span>}
            {nomination.organisationContact.email && (
              <a href={`mailto:${nomination.organisationContact.email}`}>{nomination.organisationContact.email}</a>
            )}
            {nomination.organisationContact.phone && <span>{nomination.organisationContact.phone}</span>}
          </Flex>
        </CardContent>
      )}
      {details.length > 0 && <SubmissionDetailsSection details={details} dataTestId={`nomination-${index}-details`} />}
    </CardDashboard>
  )
}
